import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

export function Layout() {
  return (
    <div className="flex h-screen bg-dark-900">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <div className="p-6 pb-24">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
